import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const addClientTicket = createAsyncThunk("tickets/addClientTicket", async (ticketData, thunkAPI) => {
  try {
    const token = localStorage.getItem("client_access_token");
    const res = await axios.post(
      `${BACKEND_URL}/ticket/add`,
      ticketData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to add ticket");
  }
});

export const getClientTickets = createAsyncThunk("tickets/getClientTickets", async (page = 1, thunkAPI) => {
  try {
    const token = localStorage.getItem("client_access_token");
    const res = await axios.get(`${BACKEND_URL}/ticket/list?${page}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch tickets");
  }
});

const ticketSlice = createSlice({
    name: "clientTickets",
    initialState: {
      clientTickets: [],
      pagination: {},
      loading: false,
      error: null,
    },
    extraReducers: (builder) => {
      builder
        .addCase(addClientTicket.fulfilled, (state, action) => {
          state.clientTickets.unshift(action.payload);
        })
        .addCase(getClientTickets.pending, (state) => {
          state.loading = true;
        })
        .addCase(getClientTickets.fulfilled, (state, action) => {
          state.clientTickets = action.payload.data;
          state.pagination = {
            current_page: action.payload.current_page,
            last_page: action.payload.last_page,
            total: action.payload.total,
          };
          state.loading = false;
        })
        .addCase(getClientTickets.rejected, (state, action) => {
          state.error = action.payload || "Failed to fetch tickets"; 
          state.loading = false;
        })
    },
});

export default ticketSlice.reducer;